export default [
    {
        path: "/player/:id",
        name: "player",
        component: () => import("./index"),
        meta: {
            title: "视频播放器"
        }
    },
]